import React from 'react';
import { withTheme } from '@emotion/react';

import { useLocalization, withLocale } from 'common/providers/LocaleProvider';
import type { GlobalHeadProps } from './BaseGlobalHead';
import { BaseGlobalHead, DEFAULT_META_VALUE } from './BaseGlobalHead';

const TRANSLATED_VALUE_REGEX = /{{([a-z0-9-_]+)}}/g;

const useTranslatedValue = (value: string) => {
  const { t } = useLocalization();

  return value ? value.replace(TRANSLATED_VALUE_REGEX, (_, key) => t(key)) : DEFAULT_META_VALUE;
};

const GlobalHead = ({ title, description, ...props }: Omit<GlobalHeadProps, 'l10n'>) => {
  const { language, region, theme } = useLocalization();

  const translatedTitle = useTranslatedValue(title);
  const translatedDescription = useTranslatedValue(description);

  const l10n = {
    language,
    region,
    theme,
  };

  return (
    <BaseGlobalHead
      l10n={l10n}
      title={translatedTitle}
      description={translatedDescription}
      shouldRenderDescription={!!description}
      {...props}
    />
  );
};

export default withLocale(withTheme(GlobalHead));
